<template>
    <div v-if="address">
        <h6 style="font-weight: bold">{{ title }}</h6>
        <span v-if="address.name">{{ address.name }}<br /></span>
        <span v-if="address.street1">{{ address.street1 }}<br /></span>
        <span v-if="address.street2">{{ address.street2 }} <br /></span>
        <span v-if="address.street3">{{ address.street3 }} <br /></span>
        <span>{{ address.postalCode }} {{ address.city }} {{ address.countryCode }}</span>

        <div v-if="address.contactPerson.mails">
            <div v-for="(item, index) in address.contactPerson.mails" v-bind:key="index">
                <span v-if="item">{{ item }}</span>
            </div>

            <span v-if="address.contactPerson.name">{{ address.contactPerson.name }}</span>
            <span v-if="address.contactPerson.phone">{{ address.contactPerson.phone }}</span>
        </div>
    </div>
</template>
<script>
export default {
    components: {},

    props: {
        address: { type: Object, required: true },
        title: { type: String, required: true }
    },

    data() {
        return {};
    },

    methods: {}
};
</script>

<style></style>
